export default {
    NETWORK_NAME_SINGULAR: 'Network',
    NETWORK_NAME_PLURAL: 'Networks',
}